
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/findpassword",
      function () {
        return require("private-next-pages/auth/findpassword.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/findpassword"])
      });
    }
  